import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

const RefreshErrorScreen = ({ className }) => (
  <div className={className}>
    <div className="is-modal-refresh">
      <img className="logo" src={`${STATIC_BASE_URL}/static/webapp/img/signin-logo.svg`} />
      <img src={`${STATIC_BASE_URL}/static/webapp/images/refresh-page.svg`} />
      <h3>Something went wrong</h3>
      <h5>Please refresh the page to continue</h5>
      <Button
        styleType="secondary"
        text="Refresh"
        onClick={() => window.location.reload()}
        id="Refresh_Error_Screen_btn"
      />
    </div>
  </div>
)

export default styled(RefreshErrorScreen)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #2f354a;
  .is-modal-refresh {
    padding: 60px 120px;
    border-radius: 10px;
    position: relative;
    background-color: white;
    box-shadow: 0 0 1px 3px rgba(0, 0, 0, 0.05);
    text-align: center;
    img {
      width: 100px;
      &.logo {
        width: 230px;
        position: absolute;
        top: -110px;
        left: calc(50% - 115px);
      }
    }
    .is-button {
      margin-top: 20px;
    }
  }
`
